import { useContext } from 'react'
//Context
import { appContext } from "../../AppContext";

const FetchType = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE"
  };

export const ApiType = {
    CORE: "/api",
};

//options.method = GET, POST, PUT, DELETE
//options.url = the url to the api
//options.body = for POST the object you want to send (this will be JSON.stringyfied)
//onDataLoaded = this method will be fired when fetch is done (isSuccess, result)
export function useFetch() {
    const [appState] = useContext(appContext);

    function doFetch(url, method, body, stopProcessing) {
        if(method === undefined) {
            method = FetchType.GET;
        }
        return preformFetch(url, method, body, stopProcessing);
    }

    async function preformFetch(url, method, body, stopProcessing) {
        const headers = new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'CustomStoryId': appState.storyId,
            "CustomLarperId": appState?.user?.id
        });
        
        let result;

        await fetch(appState.baseUrl + url, {
            method: method,
            headers: headers,
            body: JSON.stringify(body),
            credentials: 'include'
        })
            .then((response) => result = processResponse(response, stopProcessing))
            .catch(error => result = {isSuccess:false, result:error});

        return result;

    }

    async function processResponse(response, stopProcessing) {
        if(stopProcessing) {
            return {isSuccess:response.ok, result:response}
        }
        let json = ""
        try {
            json = await response.json();
        }
        catch (error) {
            console.error("Failed", error);
            return {isSuccess:false, result:response}
        }

        return {isSuccess:response.ok, result:json}
    }

    return [doFetch, FetchType]
}